import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    activeCourse: null,
    activeCourseData: {
      subject: {}
    },
    activeCourseItems: [],
    courseTypeItems: [
      {text: 'ปกติ', value: 'NORMAL'}, 
      {text: 'นานาชาติ', value: 'INTER'},
      {text: 'นานาชาติ(บางขุนเทียน)', value: 'ARCH'},
      {text: 'ราชบุรี', value: 'RATC'}
    ]
  },
  getters: {
    activeCourse (state) {
      return state.activeCourse
    },
    activeCourseData (state) {
      return state.activeCourseData
    },
    activeCourseItems (state) {
      return state.activeCourseItems
    },
    courseTypeItems (state) {
      return state.courseTypeItems
    },
  },
  mutations: {
    setActiveCourse (state, payload) {
      state.activeCourse = payload
    },
    setActiveCourseData (state, payload) {
      state.activeCourseData = payload
    },
    setActiveCourseItems (state, payload) {
      state.activeCourseItems = payload
    },
    resetActiveCourseData (state) {
      state.activeCourseData = {
        subject: {}
      }
    }
  },
  actions: {
    setActiveCourse ({ commit }, payload) {
      console.log('actions setActiveCourse', payload)
      commit('setActiveCourse', payload)
    },
    setActiveCourseData ({ commit }, payload) {
      console.log('actions setActiveCourseData', payload)
      commit('setActiveCourseData', payload)
    },
    fetchActiveCoursesByAcademicYear ({ commit, dispatch }, payload) {
      console.log(`actions fetchActiveCoursesByAcademicYear payload: ${payload}`)
      Vue.axios.get(`${config.serverURI}/activeCourses/findAllByAcademicYear/${payload}`).then((response) => {
        console.log('ActiveCourses', response.data)
        commit('setActiveCourseItems', response.data)
      }).catch((error) => {
        console.log(error)
        dispatch('snackbarOnLoadFail', error.response.data.message)
      })
    },
    fetchActiveCoursesByAcademicYearAndCourseType ({ commit, dispatch }, payload) {
      console.log('actions fetchActiveCoursesByAcademicYearAndCourseType')
      console.log('payload', payload)
      Vue.axios.get(`${config.serverURI}/activeCourses/findAllByAcademicYearAndCourseType/${payload.academicYear}/${payload.courseType}`).then((response) => {
        console.log('ActiveCourse', response.data)
        commit('setActiveCourseItems', response.data)
      }).catch((error) => {
        console.log(error)
        dispatch('snackbarOnLoadFail', error.response.data.message)
      })
    },
    createActiveCourse ({ commit, dispatch }, payload) {
      console.log('actions saveActiveCourse', payload)
      return new Promise((resolve, reject) => {
        Vue.axios.post(`${config.serverURI}/activeCourses`, payload).then((response) => {
          console.log('saveActiveCourse', response)
          dispatch('snackbarOnSaveSuccess')
          dispatch('fetchActiveCoursesByAcademicYear', payload.academicYear)
          resolve(response)
        }).catch((error) => {
          console.log('createActiveCourse error', error)
          reject(error)
          dispatch('snackbarOnLoadFail', error.response.data.message)
        })
      })
    },
    updateActiveCourse ({ commit, dispatch }, payload) {
      console.log('actions updateActiveCourse', payload)
      return new Promise((resolve, reject) => {
        Vue.axios.put(`${config.serverURI}/activeCourses/${payload.id}`, payload).then((response) => {
          console.log('updateActiveCourse response', response)
          dispatch('snackbarOnSaveSuccess')
          dispatch('fetchActiveCoursesByAcademicYear', payload.academicYear)
          resolve(response)
        }).catch((error) => {
          console.log('updateActiveCourse error', error)
          reject(error)
          dispatch('snackbarOnLoadFail', error.response.data.message)
        })
      })
    },
    resetActiveCourseData ({commit}) {
      commit('resetActiveCourseData')
    },
    loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/activeCourses`)
    },
    loadItemsByAcademicYear ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/activeCourses/findAllByAcademicYear/${payload}`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/activeCourses/page/${pagination.academicYearId}`, { params: pagination })
    },
    fetchItem ({ commit, dispatch }, payload) {
      console.log('-> fetchItem', payload)
      return Vue.axios.get(`${config.serverURI}/activeCourses/${payload}`)
    },
    fetchItemsByAcademicYearAndCourseType ({ commit, dispatch }, payload) {
      console.log('actions fetchItemsByAcademicYearAndCourseType')
      console.log('payload', payload)
      return Vue.axios.get(`${config.serverURI}/activeCourses/findAllByAcademicYearAndCourseType/${payload.academicYear}/${payload.courseType}`)
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/activeCourses`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/activeCourses/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('-> delete', payload)
      return Vue.axios.delete(`${config.serverURI}/activeCourses/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/activeCourse.js